module.exports = __webpack_public_path__ + "img/三文鱼寿司.635ab453.png";